import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { useAppContext } from '@/context/AppContext';
import PropTypes from 'prop-types';

const SnackbarNotification = ({ autoHideDuration = 6000, stackSpacing = 60, position = { vertical: 'bottom', horizontal: 'left' } }) => {
  const { events, removeEvent } = useAppContext();

  const handleClose = (index) => () => {
    removeEvent(index);
  };

  return (
    <>
      {events.map((event, index) => (
        <Snackbar
          key={index}
          open={true}
          autoHideDuration={autoHideDuration}
          onClose={handleClose(index)}
          anchorOrigin={position}
          style={{ marginBottom: index * stackSpacing }}
        >
          <Alert severity={event.type} sx={{ width: '100%' }}>
            {event.message}
          </Alert>
        </Snackbar>
      ))}
    </>
  );
};

SnackbarNotification.propTypes = {
  autoHideDuration: PropTypes.number, // Number (in ms) for how long the snackbar remains visible
  stackSpacing: PropTypes.number, // Space between stacked snackbars (in pixels)
  position: PropTypes.shape({ // Object defining the vertical and horizontal position of the snackbar
    vertical: PropTypes.oneOf(['top', 'bottom']),
    horizontal: PropTypes.oneOf(['left', 'center', 'right']),
  }),
};

export default SnackbarNotification;